import { Status } from "./Status";


export class BackgroundTaskStatusSmartEnum {
    static IsQueued = new Status("Queued", 1, "pill--yellow");
    static IsGenerating = new Status("Generating", 2, "pill--blue");
    static IsReadyForDownload = new Status("Ready For Download", 3, "pill--green");
    static FailedToGenerate = new Status("Failed To Generate", 4, "pill--red");

    public static getName() {
        // Cannot use this.name as it will be the minified value in production
        return "BackgroundTaskStatusSmartEnum";
    }
}

